"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _loginPageConfiguration = require("@/api/appBasicSetup/loginPageConfiguration");
var _appSetting = require("@/api/appSetting");
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
var _appSet = _interopRequireDefault(require("../../appSet/appSet"));
var _androidPrivacy = _interopRequireDefault(require("../../appSet/androidPrivacy"));
var _packageConfig = _interopRequireDefault(require("../../appSet/packageConfig"));
var _ossUpload = require("@/utils/ossUpload");
var _store = _interopRequireDefault(require("@/store"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      needIpad: '0',
      umengConfig: {},
      one: undefined,
      two: undefined,
      three: undefined,
      versionCodeStatus: 0,
      loadingTb: false,
      radio: '',
      versionCode: 1,
      remark: '',
      uni_appId: '',
      appName: '',
      license: '',
      privacy: '',
      mainColor: '',
      iosAppLinks: '',
      manifest: _appSet.default,
      config: _packageConfig.default,
      androidPrivacy: _androidPrivacy.default,
      wechatAppId: '',
      wechatUniversalLinks: '',
      urls: '',
      loading: false,
      loginPageDetail: {},
      tableData: [],
      statusObj: {
        0: '待调度 ',
        1: '进行中',
        2: '处理完成',
        3: '处理失败'
      },
      jigangConfig: {}
    };
  },
  computed: {
    versionName: function versionName() {
      return this.one + '.' + this.two + '.' + this.three;
    }
  },
  mounted: function mounted() {
    var _this = this;
    (0, _appSetting.searchInfo)().then(function (res) {
      _this.uni_appId = res.data.uniAppId;
      _this.appName = res.data.appName;
      _this.license = res.data.license;
      _this.privacy = res.data.privacy;
      _this.mainColor = res.data.mainColor || '#111111';
      _this.iosAppLinks = res.data.iosAppLinks || '';
    }).then(function () {
      _this.androidPrivacyBuff();
    });
    this.getPackList();
    // this.queryLatestPack()
    (0, _loginPageConfiguration.queryLoginPageDetail)().then(function (res) {
      _this.loginPageDetail = res.data;
      if (res.data.wechatLoginConfig) {
        _this.wechatAppId = res.data.wechatLoginConfig.wechatAppId;
        _this.wechatUniversalLinks = res.data.wechatLoginConfig.wechatUniversalLinks;
      }
    });
    (0, _appSetting.queryThirdPackageConfig)().then(function (res) {
      _this.umengConfig = res.data.umengConfig;
      console.log(_this.umengConfig);
    });
    (0, _threePartyConfiguration.queryThirdConfig)({
      type: 1
    }).then(function (res) {
      _this.jigangConfig = res.data.jigangConfig;
    });
    // getManifest({
    //   type: 'manifest'
    // }).then(res => {
    //   if (res.data) {
    //     console.log(JSON.parse(res.data, '======================================')
    //     )
    //   }
    // })
  },
  methods: {
    queryLatestPack: function queryLatestPack() {
      var _this2 = this;
      (0, _appSetting.getLatestPack)({
        osType: this.radio
      }).then(function (res) {
        if (res.data && res.data != null) {
          _this2.versionCode = res.data.inVersion * 1;
        } else {
          _this2.versionCode = 1;
        }
      });
    },
    changeType: function changeType() {
      this.queryLatestPack();
    },
    refresh: function refresh() {
      this.getPackList();
    },
    androidPrivacyBuff: function androidPrivacyBuff() {
      this.androidPrivacy.message = "".concat(this.appName, " \u611F\u8C22\u60A8\u4FE1\u4EFB\u5E76\u4F7F\u7528").concat(this.appName, "\uFF01<br/>\u6211\u4EEC\u6DF1\u77E5\u4E2A\u4EBA\u4FE1\u606F\u5BF9\u60A8\u7684\u91CD\u8981\u6027\uFF0C\u6211\u4EEC\u5C06\u6309\u6CD5\u5F8B\u6CD5\u89C4\u8981\u6C42\uFF0C\u91C7\u53D6\u76F8\u5E94\u5B89\u5168\u4FDD\u62A4\u63AA\u65BD\uFF0C\u5C3D\u529B\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002<br/><br/>\u5F53\u60A8\u4F7F\u7528").concat(this.appName, "APP\u524D\uFF0C\u8BF7\u60A8\u4ED4\u7EC6\u9605\u8BFB\u5E76\u7406\u89E3\uFF1A\u6211\u4EEC\u4F1A\u6839\u636E\u60A8\u4F7F\u7528\u670D\u52A1\u7684\u5177\u4F53\u529F\u80FD\u9700\u8981\uFF0C\u6536\u96C6\u5FC5\u8981\u7684\u7528\u6237\u4FE1\u606F\uFF0C\u60A8\u53EF\u901A\u8FC7\u9605\u8BFB\u300A").concat(this.appName, "\u7528\u6237\u534F\u8BAE\u300B\u548C\u300A\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u653F\u7B56\u300B\u4E86\u89E3\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u3001\u5B58\u50A8\u3001\u5206\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u60C5\u51B5\uFF0C\u4EE5\u53CA\u5BF9\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5B89\u5168\u4FDD\u62A4\u63AA\u65BD\u3002<br/><br/>\u4E3A\u4E86\u66F4\u597D\u5730\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u6743\u76CA\uFF0C\u8BF7\u60A8\u8BA4\u771F\u9605\u8BFB<a href=\"").concat(this.license, "\">\u300A").concat(this.appName, "\u7528\u6237\u534F\u8BAE\u300B</a>\u548C<a href=\"").concat(this.privacy, "\">\u300A\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u653F\u7B56\u300B</a>\uFF0C\u5982\u60A8\u7406\u89E3\u5E76\u63A5\u53D7\u4E0A\u8FF0\u534F\u8BAE\u7684\u5185\u5BB9\uFF0C\u8BF7\u70B9\u51FB\u201C\u540C\u610F\u201D\u5F00\u59CB\u63A5\u53D7\u6211\u4EEC\u7684\u670D\u52A1\u3002");
      this.androidPrivacy.second.title = "\u6B22\u8FCE\u4F7F\u7528".concat(this.appName);
      this.androidPrivacy.second.message = "\u5982\u679C\u60A8\u9009\u62E9\u201C\u4ECD\u4E0D\u540C\u610F\u201D\uFF0C\u90A3".concat(this.appName, "\u65E0\u6CD5\u4E3A\u60A8\u63D0\u4F9B\u66F4\u591A\u670D\u52A1\uFF0C\u5E76\u4E14\u4F1A\u9000\u51FA\u8BE5\u5E94\u7528");
      this.androidPrivacy.styles.buttonAccept.color = this.mainColor;
      // console.log(this.androidPrivacy)
    },
    sendAndroidPrivacy: function () {
      var _sendAndroidPrivacy = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var jsonContent, blob, file;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              jsonContent = JSON.stringify(this.androidPrivacy, null, 2);
              blob = new Blob([jsonContent], {
                type: 'application/json'
              });
              file = new File([blob], 'androidPrivacy.json', {
                type: blob.type
              });
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file, 'builds', 'androidPrivacy.json');
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function sendAndroidPrivacy() {
        return _sendAndroidPrivacy.apply(this, arguments);
      }
      return sendAndroidPrivacy;
    }(),
    linkOver: function linkOver(val) {
      var _this3 = this;
      (0, _appSetting.finishPack)({
        id: val.id
      }).then(function (res) {
        _this3.getPackList();
      });
    },
    linkDown: function linkDown(val) {
      if (val.link) {
        window.location.href = val.link;
      }
    },
    getPackList: function getPackList() {
      var _this4 = this;
      this.loadingTb = true;
      (0, _appSetting.listPack)().then(function (res) {
        _this4.tableData = res.data;
        _this4.loadingTb = false;
      }).catch(function () {
        _this4.loadingTb = false;
      });
    },
    begin: function begin() {
      var _this5 = this;
      (0, _appSetting.runPack)({
        osType: this.radio,
        buildVersion: this.versionName,
        remark: this.remark,
        inVersion: this.versionCodeStatus === 1 ? this.versionCode + 1 : this.versionCode
      }).then(function (res) {
        console.log(res);
        _this5.loading = false;
        if (res.data) {
          _this5.$notify.success({
            title: '温馨提示',
            message: '启动成功！'
          });
          _this5.getPackList();
          _this5.queryLatestPack();
        }
      }).catch(function () {
        _this5.loading = false;
      });
    },
    setManifest: function () {
      var _setManifest = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(val) {
        var jsonContent, blob, file, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // app配置文件
              this.manifest.appid = this.uni_appId;
              this.manifest.name = this.appName;
              this.manifest.description = this.appName;
              this.manifest.versionName = this.versionName;
              this.manifest.versionCode = this.versionCodeStatus === 1 ? this.versionCode + 1 : this.versionCode;
              this.manifest['app-plus'].nativePlugins['xiguazhu-baichuan']['__plugin_info__']['android_package_name'] = val.androidPackageName;
              this.manifest['app-plus'].nativePlugins['xiguazhu-baichuan']['__plugin_info__']['ios_bundle_id'] = val.iosPackageName;
              this.manifest['app-plus'].nativePlugins['CGF-ExitIosApp']['__plugin_info__']['android_package_name'] = val.androidPackageName;
              this.manifest['app-plus'].nativePlugins['CGF-ExitIosApp']['__plugin_info__']['ios_bundle_id'] = val.iosPackageName;
              this.manifest['app-plus'].nativePlugins['JG-JCore']['__plugin_info__']['ios_bundle_id'] = val.iosPackageName;
              this.manifest['app-plus'].nativePlugins['JG-JCore']['__plugin_info__']['android_package_name'] = val.androidPackageName;
              this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['ios_bundle_id'] = val.iosPackageName;
              this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['android_package_name'] = val.androidPackageName;
              this.manifest['app-plus'].nativePlugins['JG-JVerification']['__plugin_info__']['ios_bundle_id'] = val.iosPackageName;
              this.manifest['app-plus'].nativePlugins['JG-JVerification']['__plugin_info__']['android_package_name'] = val.androidPackageName;
              if (this.jigangConfig) {
                this.manifest['app-plus'].nativePlugins['JG-JCore']['JPUSH_APPKEY_ANDROID'] = this.jigangConfig.jguangBaseConfig.androidAppKey;
                this.manifest['app-plus'].nativePlugins['JG-JCore']['JPUSH_APPKEY_IOS'] = this.jigangConfig.jguangBaseConfig.iosAppKey;
                this.manifest['app-plus'].nativePlugins['JG-JCore']['__plugin_info__']['parameters']['JPUSH_APPKEY_ANDROID']['value'] = this.jigangConfig.jguangBaseConfig.androidAppKey;
                this.manifest['app-plus'].nativePlugins['JG-JCore']['__plugin_info__']['parameters']['JPUSH_APPKEY_IOS']['value'] = this.jigangConfig.jguangBaseConfig.iosAppKey;
                if (this.jigangConfig.honorConfig && this.jigangConfig.honorConfig != null) {
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_HONOR_APPID']['value'] = this.jigangConfig.honorConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_HONOR_APPID'] = this.jigangConfig.honorConfig.appId;
                }
                if (this.jigangConfig.huaweiConfig && this.jigangConfig.huaweiConfig != null) {
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_HUAWEI_APPID']['value'] = 'appid=' + this.jigangConfig.huaweiConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_HUAWEI_APPID'] = 'appid=' + this.jigangConfig.huaweiConfig.appId;
                }
                if (this.jigangConfig.oppoConfig && this.jigangConfig.oppoConfig != null) {
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_OPPO_APPID']['value'] = 'OP-' + this.jigangConfig.oppoConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_OPPO_APPID'] = 'OP-' + this.jigangConfig.oppoConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_OPPO_APPKEY']['value'] = 'OP-' + this.jigangConfig.oppoConfig.appKey;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_OPPO_APPKEY'] = 'OP-' + this.jigangConfig.oppoConfig.appKey;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_OPPO_APPSECRET']['value'] = 'OP-' + this.jigangConfig.oppoConfig.appSecret;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_OPPO_APPSECRET'] = 'OP-' + this.jigangConfig.oppoConfig.appSecret;
                }
                if (this.jigangConfig.vivoConfig && this.jigangConfig.vivoConfig != null) {
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_VIVO_APPID']['value'] = this.jigangConfig.vivoConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_VIVO_APPID'] = this.jigangConfig.vivoConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_VIVO_APPKEY']['value'] = this.jigangConfig.vivoConfig.appKey;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_VIVO_APPKEY'] = this.jigangConfig.vivoConfig.appKey;
                }
                if (this.jigangConfig.xiaomiConfig && this.jigangConfig.xiaomiConfig != null) {
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_XIAOMI_APPID']['value'] = 'MI-' + this.jigangConfig.xiaomiConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_XIAOMI_APPID'] = 'MI-' + this.jigangConfig.xiaomiConfig.appId;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['__plugin_info__']['parameters']['JPUSH_XIAOMI_APPKEY']['value'] = 'MI-' + this.jigangConfig.xiaomiConfig.appKey;
                  this.manifest['app-plus'].nativePlugins['JG-JPush']['JPUSH_XIAOMI_APPKEY'] = 'MI-' + this.jigangConfig.xiaomiConfig.appKey;
                }
              }
              this.manifest['app-plus'].distribute.ios.urltypes = [{
                urlschemes: ['tbopen' + val.ios_bc_AppKey]
              }];
              this.manifest['app-plus'].distribute.ios.appid = val.iosPackageName;
              this.manifest['app-plus'].distribute.ios.privacyDescription.NSLocalNetworkUsageDescription = this.appName + '需要访问您的本地网络';
              this.manifest['app-plus'].distribute.ios.capabilities.entitlements['com.apple.developer.associated-domains'] = ["".concat(this.iosAppLinks || '')];
              if (this.loginPageDetail.wechatLoginConfig.wechatStatus === 1) {
                // 微信登录打开
                this.manifest['app-plus'].distribute.sdkConfigs.oauth['weixin'] = {
                  UniversalLinks: this.wechatUniversalLinks,
                  appid: this.wechatAppId
                };
                this.manifest['app-plus'].distribute.sdkConfigs.share['weixin'] = {
                  UniversalLinks: this.wechatUniversalLinks,
                  appid: this.wechatAppId
                };
              }
              if (this.radio === '0') {
                // 安卓友盟
                if (this.umengConfig && this.umengConfig.androidAppKey) {
                  this.manifest['app-plus'].distribute.sdkConfigs.statics['umeng'] = {
                    'appkey_android': this.umengConfig.androidAppKey,
                    'channelid_android': 'um-android'
                  };
                } else {
                  this.manifest['app-plus'].distribute.sdkConfigs.statics = {};
                }
              } else {
                // ios友盟
                if (this.umengConfig && this.umengConfig.iosAppKey) {
                  this.manifest['app-plus'].distribute.sdkConfigs.statics['umeng'] = {
                    'appkey_ios': this.umengConfig.iosAppKey,
                    'channelid_ios': 'um-ios'
                  };
                } else {
                  this.manifest['app-plus'].distribute.sdkConfigs.statics = {};
                }
              }
              jsonContent = JSON.stringify(this.manifest, null, 2);
              blob = new Blob([jsonContent], {
                type: 'application/json'
              });
              file = new File([blob], 'manifest.json', {
                type: blob.type
              });
              _context2.n = 1;
              return (0, _ossUpload.uploadOSS)(file, 'builds', 'manifest.json');
            case 1:
              res = _context2.v;
              this.urls = res;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function setManifest(_x) {
        return _setManifest.apply(this, arguments);
      }
      return setManifest;
    }(),
    setConfig: function () {
      var _setConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(val) {
        var jsonContent, blob, file;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              // 打包配置文件
              if (this.radio === '0') {
                this.config.platform = 'android';
                this.config.android.certalias = val.androidBookName || this.uni_appId;
                this.config.android.certfile = "/Users/".concat(process.env.NODE_ENV === 'development' ? 'yanghui' : 'halt', "/Documents/HBuilderProjects/package-malt-app/build_config/android.keystore");
                this.config.android.certpassword = val.androidPsd;
                this.config.android.storePassword = val.androidPsd;
                this.config.android.packagename = val.androidPackageName;
              } else {
                if (this.needIpad === '1') {
                  // 打包是否支持ipad
                  this.config.ios.supporteddevice = 'iPhone,iPad';
                } else {
                  this.config.ios.supporteddevice = 'iPhone';
                }
                this.config.platform = 'ios';
                this.config.ios.bundle = val.iosPackageName;
                this.config.ios.certpassword = val.iosPsd;
                this.config.ios.certfile = "/Users/".concat(process.env.NODE_ENV === 'development' ? 'yanghui' : 'halt', "/Documents/HBuilderProjects/package-malt-app/build_config/ios.p12");
                this.config.ios.profile = "/Users/".concat(process.env.NODE_ENV === 'development' ? 'yanghui' : 'halt', "/Documents/HBuilderProjects/package-malt-app/build_config/ios.mobileprovision");
              }
              jsonContent = JSON.stringify(this.config, null, 2);
              blob = new Blob([jsonContent], {
                type: 'application/json'
              });
              file = new File([blob], 'config.json', {
                type: blob.type
              });
              _context3.n = 1;
              return (0, _ossUpload.uploadOSS)(file, 'builds', 'config.json');
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function setConfig(_x2) {
        return _setConfig.apply(this, arguments);
      }
      return setConfig;
    }(),
    sendAppSetting: function () {
      var _sendAppSetting = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(val) {
        var jsonContent, blob, file;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              jsonContent = JSON.stringify({
                packageName: val.androidPackageName || val.iosPackageName,
                appId: _store.default.getters.appId,
                appName: this.appName,
                license: this.license,
                privacy: this.privacy,
                wechatStatus: this.loginPageDetail.wechatLoginConfig.wechatStatus,
                uniStatus: this.loginPageDetail.uniConfig.uniStatus
              }, null, 2);
              blob = new Blob([jsonContent], {
                type: 'application/json'
              });
              file = new File([blob], 'appSetting.json', {
                type: blob.type
              });
              _context4.n = 1;
              return (0, _ossUpload.uploadOSS)(file, 'builds', 'appSetting.json');
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function sendAppSetting(_x3) {
        return _sendAppSetting.apply(this, arguments);
      }
      return sendAppSetting;
    }(),
    save: function save() {
      var _this6 = this;
      if (!this.radio) {
        this.$message.error('请先选择需要打包的平台');
        return;
      }
      if (this.one === undefined || this.two === undefined || this.three === undefined) {
        this.$message.error('请填写正确的版本号');
        return;
      }
      var confirmTextList = ["\u5E73\u53F0:".concat(this.radio === '0' ? '安卓' : '苹果'), "\u7248\u672C\u53F7:".concat(this.one + '.' + this.two + '.' + this.three), "\u5185\u5EFA\u7248\u672C\u53F7:".concat(this.versionCodeStatus === 1 ? this.versionCode + 1 : this.versionCode)];
      var newDatas = [];
      var h = this.$createElement;
      for (var i in confirmTextList) {
        newDatas.push(h('p', null, confirmTextList[i]));
      }
      this.$confirm('提示', {
        title: '确认是否要启动打包？',
        message: h('div', null, newDatas),
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this6.loading = true;
        (0, _appSetting.getManifest)({
          type: 'packConfig'
        }).then(function (res) {
          if (res.data) {
            var obj = JSON.parse(res.data);
            _this6.setManifest(obj);
            _this6.setConfig(obj);
            _this6.sendAppSetting(obj);
            _this6.sendAndroidPrivacy();
          } else {
            _this6.loading = false;
            _this6.$message.info('请先上传证书信息');
          }
        }).then(function () {
          setTimeout(function () {
            _this6.begin();
          }, 2500);
        }).catch(function () {
          _this6.loading = false;
        });
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};